import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "emerald-gold", setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme] = useState("emerald-gold");
  useEffect(() => {
    localStorage.removeItem("sam-theme");
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);
  return (
    <ThemeContext.Provider value={{ theme, setTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
